import React from "react";

const CommandPrefix = (props) => {
  const { user, at } = props;
  return (
    <span className="command-prefix">
      <span>{user}</span>@<span>{at}</span>:~$
    </span>
  );
};

export default CommandPrefix;
